import { Component, OnInit } from '@angular/core';
import { CONSTANTS } from 'src/app/constants/users.constants';
import { API_PAY_IN_STATUS_TITLES, API_PAY_IN_VOUCHER_CONSTANTS, FLUTTER_API_PAY_IN_STATUS, GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { PrintServicesService } from 'src/app/services/print-services.service';
import moment from 'moment';
import { ApiPayInAlertService } from '../../../services/api-pay-in-alert.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { Transaction } from 'src/app/models';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-api-pay-in-voucher',
  templateUrl: './api-pay-in-voucher.component.html',
  styleUrls: ['./api-pay-in-voucher.component.scss']
})
export class ApiPayInVoucherComponent implements OnInit {
  transaction: Transaction;
  transactionDetails: any;
  currentDate = moment().format(API_PAY_IN_VOUCHER_CONSTANTS.DATE_FORMAT);
  status: string;
  loading: boolean = true;
  timeIntervalToRequestAgain = GENERAL_CONSTANTS.TIME_OUT_TO_RETRY;
  startDelay: boolean = false;
  successState: string = FLUTTER_API_PAY_IN_STATUS.SUCCESS;
  failedState: string = FLUTTER_API_PAY_IN_STATUS.FAILED;
  showVoucher: boolean;

  static loadStyle() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `./assets/css/root/default.css`;
    document.getElementsByTagName(API_PAY_IN_VOUCHER_CONSTANTS.HEAD)[0].appendChild(link);
  }

  constructor(
    private readonly apiPayInAlertService: ApiPayInAlertService,
    private readonly printServicesService: PrintServicesService,
    private readonly tokenService: TokenServiceService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.transactionDetails = JSON.parse(localStorage.getItem(FLUTTER_API_PAY_IN_STATUS.PENDING_EXTERNAL_PAYMENT_FLOW) ?? '').transactionDetails;
    this.transaction = this.tokenService.getAndDecodeCustomToken(this.transactionDetails.token);
    const currentUrlToken = this.route.snapshot.queryParamMap.get('token');

    if (!currentUrlToken) this.router.navigate([], { relativeTo: this.route, queryParams: { token: this.transactionDetails.token }, })

    await this.processApiPayInTransaction();

    ApiPayInVoucherComponent.loadStyle();
  }

  /**
   * @description Function to print the payment receipt
  */
  printPaymentReceipt() {
    this.printServicesService.downloadImage(document.getElementById('voucherBox'), CONSTANTS.PAYMENT_RECEIPT_TITLE);
  }

  /**
   * @description Function to retry the payment
  */
  intervalLogic() {
    const retryRequestInterval = setInterval(async () => {
        if (this.timeIntervalToRequestAgain <= 0) {
            this.timeIntervalToRequestAgain = GENERAL_CONSTANTS.TIME_OUT_TO_RETRY;

            clearInterval(retryRequestInterval);

            this.startDelay = true;

            await this.processApiPayInTransaction();
        } else {
            this.timeIntervalToRequestAgain = this.timeIntervalToRequestAgain - 1;
        }
    }, 1000);
  }

  /**
   * @description Function to process the payment
  */
  async processApiPayInTransaction() {
    await this.apiPayInAlertService.getTransactionStatus(this.transactionDetails.transactionId, this.transactionDetails.token).then((response: any) => {
      switch(response.DATA.status) {
        case FLUTTER_API_PAY_IN_STATUS.SUCCESS:
          this.status = API_PAY_IN_STATUS_TITLES.SUCCESS;
          this.showVoucher = true;
          this.loading = false;

          localStorage.removeItem(FLUTTER_API_PAY_IN_STATUS.PENDING_EXTERNAL_PAYMENT_FLOW);

          break;

        case FLUTTER_API_PAY_IN_STATUS.FAILED:
          this.status = API_PAY_IN_STATUS_TITLES.FAILED;
          this.showVoucher = true;
          this.loading = false;

          localStorage.removeItem(FLUTTER_API_PAY_IN_STATUS.PENDING_EXTERNAL_PAYMENT_FLOW);

          break;

        default:
          this.timeIntervalToRequestAgain = GENERAL_CONSTANTS.TIME_OUT_TO_RETRY;
          this.showVoucher = false;
          this.loading = false;

          this.intervalLogic();

          break;
      }
    });
  }
}
